(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('discount-reason', {
            parent: 'entity',
            url: '/discount-reason?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.discountReason.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-reason/discount-reasons.html',
                    controller: 'DiscountReasonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discountReason');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('discount-reason-detail', {
            parent: 'entity',
            url: '/discount-reason/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.discountReason.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-reason/discount-reason-detail.html',
                    controller: 'DiscountReasonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discountReason');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DiscountReason', function($stateParams, DiscountReason) {
                    return DiscountReason.get({id : $stateParams.id});
                }]
            }
        })
        .state('discount-reason.new', {
            parent: 'discount-reason',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-reason/discount-reason-dialog.html',
                    controller: 'DiscountReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('discount-reason', null, { reload: true });
                }, function() {
                    $state.go('discount-reason');
                });
            }]
        })
        .state('discount-reason.edit', {
            parent: 'discount-reason',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-reason/discount-reason-dialog.html',
                    controller: 'DiscountReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DiscountReason', function(DiscountReason) {
                            return DiscountReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discount-reason.delete', {
            parent: 'discount-reason',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-reason/discount-reason-delete-dialog.html',
                    controller: 'DiscountReasonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DiscountReason', function(DiscountReason) {
                            return DiscountReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
